import AdmissionUtilization from '../../../public/Images/AccessDashboard/AdmissionUtilization.png';
import ProcedureUtilization from '../../../public/Images/AccessDashboard/ProcedureUtilization.png';
import DiseaseManagement from '../../../public/Images/AccessDashboard/DiseaseManagement.png';
import CareQualityMeasures from '../../../public/Images/AccessDashboard/CareQualityMeasures.png';
import ChronicPrevalenceAnalysis from '../../../public/Images/AccessDashboard/ChronicPrevalenceAnalysis.png';
import ClaimsManagement from '../../../public/Images/AccessDashboard/ClaimsManagement.png';
// import DeductibleCorridors from '../../../public/Images/AccessDashboard/DeductibleCorridors.png';
import DiseaseAnalysisPrevalence from '../../../public/Images/AccessDashboard/DiseaseAnalysisPrevalence.png';
// import DiseasePrognosis from '../../../public/Images/AccessDashboard/DiseasePrognosis.png';
import DrugUtilization from '../../../public/Images/AccessDashboard/DrugUtilization.png';
import DrugUtilizationSummary from '../../../public/Images/AccessDashboard/DrugUtilizationSummary.png';
import EnrollmentMetrics from '../../../public/Images/AccessDashboard/EnrollmentMetrics.png';
import EpisodesOfCare from '../../../public/Images/AccessDashboard/EpisodesOfCare.png';
// import HighCostClaimants from '../../../public/Images/AccessDashboard/HighCostClaimants.png';
import MedicalClaimUtilization from '../../../public/Images/AccessDashboard/MedicalClaimUtilization.png';
import MedPharmaDrugUtilization from '../../../public/Images/AccessDashboard/MedPharmaDrugUtilization.png';
import NetworkLeakage from '../../../public/Images/AccessDashboard/NetworkLeakage.png';
import OtherPrescriptionDrugUtilization from '../../../public/Images/AccessDashboard/OtherPrescriptionDrugUtilization.png';
import PendingClaims from '../../../public/Images/AccessDashboard/PendingClaims.png';
import PlanPerformance from '../../../public/Images/AccessDashboard/PlanPerformance.png';
import PlanUtilization from '../../../public/Images/AccessDashboard/PlanUtilization.png';
import ProviderUtilization from '../../../public/Images/AccessDashboard/ProviderUtilization.png';
import RejectedClaims from '../../../public/Images/AccessDashboard/RejectedClaims.png';
import ReportPlan from '../../../public/Images/AccessDashboard/ReportPlan.png';
import SpecialityDrugUtilization from '../../../public/Images/AccessDashboard/SpecialityDrugUtilization.png';
import StopLossTriggers from '../../../public/Images/AccessDashboard/StopLossTriggers.png';
import StopLossUtilization from '../../../public/Images/AccessDashboard/StopLossUtilization.png';
// import WasteCalculator from '../../../public/Images/AccessDashboard/WasteCalculator.png';
import CostManagement from '../../../public/Images/AccessDashboard/CostManagement.png';
import ClaimsMetrics from '../../../public/Images/AccessDashboard/ClaimsMetrics.png';
import SummaryOfBenefits from '../../../public/Images/AccessDashboard/SummaryOfBenefits.png';
import Contracts from '../../../public/Images/AccessDashboard/Contracts.png';
import StopLossAggregateReport from '../../../public/Images/AccessDashboard/StopLossAggregateReport.png';
import CustomQueryBuilder from '../../../public/Images/AccessDashboard/CustomQueryBuilder.png';
import ClaimAnalysis from '../../../public/Images/AccessDashboard/ClaimAnalysis.png';
import ContractAnalysis from '../../../public/Images/AccessDashboard/ContractAnalysis.png';
import KPITracker from '../../../public/Images/AccessDashboard/KPITracker.png';
import ClaimsList from '../../../public/Images/AccessDashboard/ClaimsList.png';
import MembersList from '../../../public/Images/AccessDashboard/MembersList.png';
import RiskProfile from '../../../public/Images/AccessDashboard/RiskProfile.png';
import ChronicConditions from '../../../public/Images/AccessDashboard/ChronicConditions.png';
import TriggerConditions from '../../../public/Images/AccessDashboard/TriggerConditions.png';
import HighCostUtilization from '../../../public/Images/AccessDashboard/HighCostUtilization.png';
import MultipleDrugs from '../../../public/Images/AccessDashboard/MultipleDrugs.png';
import CostPercentile from '../../../public/Images/AccessDashboard/CostPercentile.png';
import CohortAnalysis from '../../../public/Images/AccessDashboard/CohortAnalysis.png';
import CohortChronicCondition from '../../../public/Images/AccessDashboard/Cohort_Chronic_Condition.png';
// import CohortDrug from '../../../public/Images/AccessDashboard/Cohort_Drug.png';
import CohortHighCost from '../../../public/Images/AccessDashboard/Cohort_High_Cost.png';
import FinancialForensics from '../../../public/Images/AccessDashboard/FinancialForensics.png';
import BuildScenarios from '../../../public/Images/AccessDashboard/BuildScenarios.png';
import Reconciliation from '../../../public/Images/AccessDashboard/Reconciliation.png';
import DeepDive from '../../../public/Images/AccessDashboard/DeepDive.png';
import TrendAnalysis from '../../../public/Images/AccessDashboard/TrendAnalysis.png';
import CohortComparison from '../../../public/Images/AccessDashboard/CohortComparison.png';
import ComplianceReportBuilder from '../../../public/Images/AccessDashboard/ComplianceReportBuilder.png';
import ClaimsReportBuilder from '../../../public/Images/AccessDashboard/ClaimsReportBuilder.png';
import DocumentReportBuilder from '../../../public/Images/AccessDashboard/DocumentReportBuilder.png';
import MAndAReportBuilder from '../../../public/Images/AccessDashboard/M&AReportBuilder.png';
import TermReportBuilder from '../../../public/Images/AccessDashboard/TermReportBuilder.png';
import DraftReportBuilder from '../../../public/Images/AccessDashboard/DraftReportBuilder.png';
import AnnualRenewalProcess from '../../../public/Images/AccessDashboard/AnnualRenewalProcess.png';
import PlaybookAndStandard from '../../../public/Images/AccessDashboard/PlaybookAndStandard.png';
import PaymentIntegrity from '../../../public/Images/AccessDashboard/PaymentIntegrity.png';
import CMSBenchmarking from '../../../public/Images/AccessDashboard/CMSBenchmarking.png';
import DraftProposal from '../../../public/Images/AccessDashboard/DraftProposal.png';

const accessDashboardConstants = {
  TITLE: 'Analytics Suite',
  SUB_TITLE:
    'Unlock the full story behind your healthcare data with our comprehensive analytics suite from pinpointing disease trends to financial foresight',
  PLAN_DOCUMENTS_TITLE: 'Contracts AIQ',
  PLAN_DOCUMENTS_SUBTITLE:
    'Streamline Compliance with Automated Workflows: Policies, Contracts, Playbooks & Reports at Your Fingertips',
  ALL_REPORTS_TITLE: 'PDF Reports Builder',
  ALL_REPORTS_SUBTITLE:
    'One place to create, combine, and download all analytics and compliance PDFs.',
  CUSTOM_ANALYSIS_TITLE: 'Custom Analysis',
  CUSTOM_ANALYSIS_SUBTITLE:
    'Dive into a tailored examination of your healthcare data, where Custom Analysis serves as the gateway to bespoke insights and strategic oversight.',
  RECOMENDATIONS_TITLE: 'Recommendations',
  RECOMMENDATIONS_SUBTITLE:
    'Engage with our Recommendation Engine, a powerful tool designed to elevate population health, streamline costs, and ensure compliance.',
  PLAYBOOKS_AND_REPORTS: 'Tools',
  CLAIMS_AND_MEMBERS: 'Claims and Members',
  PLAN_DOCUMENTS_TITLE1: 'Plan Documents & Contracts',
  DASHBOARD_CARDS: [
    {
      category: 'Executive Summary',
      subTitle:
        'Interactive dashboard summarizing plan financials, spend trends, risk tiers, high-cost claimants, and top utilization categories',
      path: '/summary',
      image: DeepDive,
    },
    {
      category: 'Disease Management',
      subTitle:
        'Focuses on insights into the prevalence, progression, and management of diseases within a population, aiming to identify, predict, and evaluate care for chronic conditions and disease risks.',
      image: DiseaseManagement,
      subGroups: [
        {
          group: 'Disease and Condition Spend',
          subTitle:
            'Cost and utilization patterns across diagnoses, conditions, and encounters—highlighting major cost drivers and opportunities for targeted health interventions—using ICD classification from the National Center for Health Statistics (NCHS).',
          image: DiseaseAnalysisPrevalence,
          path: '/disease-prelavence',
        },
        {
          group: 'Chronic Prevalence Analysis',
          subTitle:
            'Presents a comprehensive overview of chronic disease prevalence, featuring prevalence rates, cost analysis, and exploring potential interrelationships between conditions.',
          image: ChronicPrevalenceAnalysis,
          path: '/chronic-prelavence',
        },
        // {
        //   group: 'Disease Prognosis',
        //   subTitle:
        //     'Predicts potential disease progression within the next 12-24 months, focusing on members at risk and those already diagnosed to aid in preventative strategies.',
        //   image: DiseasePrognosis,
        //   path: '/rising-risk',
        // },
        {
          group: 'Care Gaps',
          subTitle:
            'Evaluates healthcare quality by identifying gaps in recommended preventive care and comparing performance against national HEDIS measures.',
          image: CareQualityMeasures,
          path: '/care-quality',
        },
      ],
    },
    {
      category: 'Fiscal Controls',
      subTitle:
        'A single view to review fixed and variable costs, experiment with key variables, and uncover savings.',
      image: FinancialForensics,
      subGroups: [
        {
          group: 'Fiscal Controls',
          subTitle:
            'A single view to review fixed and variable costs, experiment with key variables, and uncover savings.',
          image: FinancialForensics,
          path: '/financial-forensics',
        },
        {
          group: 'Scenario Library',
          subTitle:
            'Forecast, Compare & Optimize Financial Scenarios Across Plan Years',
          image: BuildScenarios,
          path: '/scenario-library',
        },
        {
          group: 'Reconciliation Library',
          subTitle:
            'Streamline and Optimize Financial Reconciliation Processes',
          image: Reconciliation,
          path: '/reconciliation-library',
        },
      ],
    },
    {
      category: 'Cost Management',
      subTitle:
        'Analyzes and optimizes healthcare costs associated with medical episodes, identifies wasteful spending, and spotlights high-cost claimants to enhance financial efficiency.',
      image: CostManagement,
      subGroups: [
        {
          group: 'Episodes of Care',
          subTitle:
            'Analyzes costs associated with specific healthcare episodes, including pre- and post-surgery care, to assess cost variances and quality of care.',
          image: EpisodesOfCare,
          path: '/episodes-of-care',
        },
        // {
        //   group: 'Waste Calculator',
        //   subTitle:
        //     'Quantifies waste in healthcare, targeting avoidable admissions, imaging overuse, and unnecessary drug and procedure utilization.',
        //   image: WasteCalculator,
        //   path: '/waste-calculator',
        // },
        // {
        //   group: 'High Cost Claimants',
        //   subTitle:
        //     'Identifies members with significant medical or pharmacy claims, showcasing their disproportionate impact on overall plan spending.',
        //   image: HighCostClaimants,
        //   path: '/high-cost-claims',
        // },
        {
          group: 'High Cost Claimants',
          subTitle:
            'When curbing health care costs, the conversation invariably turns to the sickest 10% of the population, who consume 70% of health care spending.',
          image: TriggerConditions,
          path: '/high-cost-claims',
        },
      ],
    },
    {
      category: 'Stop Loss Management',
      subTitle:
        'Manages and mitigates financial risks associated with stop loss insurance, focusing on identifying conditions that trigger stop loss claims, analyzing deductible levels, and evaluating financial impact.',
      image: StopLossUtilization,
      subGroups: [
        {
          group: 'Stop Loss Aggregate Report',
          subTitle:
            'Detailed Monthly Breakdown of Paid Claims, Coverage Limits, and Enrollee Statistics',
          image: StopLossAggregateReport,
          path: '/stoploss-report',
        },
        {
          group: '50-50 Report Plan',
          subTitle:
            'Reveals the impact of common stop loss deductible levels on member claims, showing the percentage of members exceeding these thresholds.',
          image: ReportPlan,
          path: '/report-plan',
        },
        {
          group: 'Stop Loss Triggers',
          subTitle:
            'Identifies conditions prone to trigger stoploss claims, based on SIIA criteria, including member counts and cost contributions.',
          image: StopLossTriggers,
          path: '/stoploss-triggers',
        },
        // {
        //   group: 'Deductible Corridors',
        //   subTitle:
        //     'Analyzes the effect of adjusting deductible corridors for stop loss and captive plans, including historical data on member claims surpassing these limits.',
        //   image: DeductibleCorridors,
        //   path: '/specific-deductible-corridors',
        // },
      ],
    },
    {
      category: 'Plan Analysis',
      subTitle:
        "Provides a comprehensive analysis of the healthcare plan's performance, including claims cost distribution, enrollment metrics, and the effect of network usage on expenses.",
      image: PlanUtilization,
      subGroups: [
        {
          group: 'Plan Performance',
          subTitle:
            'Offers an in-depth analysis of claims costs over time, including insights into network usage and the distribution of medical/Rx costs.',
          image: PlanPerformance,
          path: '/plan-performance',
        },
        {
          group: 'Claims Metrics',
          subTitle:
            'Details a breakdown of all plan charges by member and network, facilitating financial oversight.',
          image: ClaimsMetrics,
          path: '/claims-metrics',
        },
        {
          group: 'Enrollment Metrics',
          subTitle:
            'Details member demographics and their selected plan types, aiding in plan design and management.',
          image: EnrollmentMetrics,
          path: '/enrollment-metrics',
        },
        {
          group: 'Network Usage',
          subTitle:
            'Compares the distribution and cost implications of in-network versus out-of-network provider claims.',
          image: NetworkLeakage,
          path: '/network-leakage',
        },
      ],
    },
    {
      category: 'Claims Management',
      subTitle:
        'Dedicated to the operational aspect of managing healthcare claims, aiming to improve the efficiency of claims processing and reduce administrative costs.',
      image: ClaimsManagement,
      subGroups: [
        {
          group: 'Rejected Claims',
          subTitle:
            'Tracks the distribution and trends of rejected claims to identify potential areas for operational improvement.',
          image: RejectedClaims,
          path: '/rejected-claims',
        },
        {
          group: 'Pending Claims',
          subTitle:
            'Displays the timeline of claims submission and payment, highlighting delays in claims processing.',
          image: PendingClaims,
          path: '/pending-claims',
        },
      ],
    },
    {
      category: 'Medical Claim Utilization',
      subTitle:
        'Focuses on the utilization of medical services, aiming to understand patterns in service utilization, identify cost reduction areas, and ensure appropriate use of resources.',
      image: MedicalClaimUtilization,
      subGroups: [
        {
          group: 'Admission Utilization',
          subTitle:
            'Focuses on hospital admission trends, including the average stay duration and inpatient days per 100 claims.',
          image: AdmissionUtilization,
          path: '/patient-admission',
        },
        {
          group: 'Procedure Utilization',
          subTitle:
            'Examines the expenditure and impact of various medical procedures on plan costs.',
          image: ProcedureUtilization,
          path: '/procedure-utilization',
        },
        {
          group: 'Provider Utilization',
          subTitle:
            'Lists the most utilized facilities and physicians by plan members, offering insights into provider selection.',
          image: ProviderUtilization,
          path: '/provider-utilization',
        },
        {
          group: 'MedPharma Drug Utilization',
          subTitle:
            'Showcases expenditure on MedPharma drugs and identifies the drug types with the highest impact on the plan.',
          image: MedPharmaDrugUtilization,
          path: '/med-pharma',
        },
      ],
    },
    {
      category: 'Drug Utilization',
      subTitle:
        'Analyzes spending and trends in drug utilization, aiming to provide a detailed overview of pharmaceutical expenditures and optimize drug spending.',
      image: DrugUtilization,
      subGroups: [
        {
          group: 'Drug Utilization Summary',
          subTitle:
            'Summarizes broad categorization spending and cost trends of drug spend, including a list of top drugs across various categories, providing a comprehensive overview of drug utilization impacts.',
          image: DrugUtilizationSummary,
          path: '/rx-utilization',
        },
        {
          group: 'MedPharma Drug Utilization',
          subTitle:
            'Showcases expenditure on MedPharma drugs and identifies the drug types with the highest impact on the plan.',
          image: MedPharmaDrugUtilization,
          path: '/med-pharma',
        },
        {
          group: 'Specialty Drug Utilization',
          subTitle:
            'Highlights spending on specialty drugs and pinpoints drug types with significant plan implications.',
          image: SpecialityDrugUtilization,
          path: '/speciality-drugs',
        },
        {
          group: 'Non-Speciality Drug Utilization',
          subTitle:
            'Examines spending on Non-Speciality drugs beyond MedPharma and specialty categories, identifying high-impact drug types.',
          image: OtherPrescriptionDrugUtilization,
          path: '/other-prescription',
        },
        {
          group: 'GLP-1 Drug Utilization',
          subTitle:
            'Analyzes usage, spending, and member demographics for GLP drugs, identifying whether they are used by members with or without a diabetes diagnosis.',
          image: MultipleDrugs,
          path: '/glp-drugs',
        },
        {
          group: 'Savings Utilization',
          subTitle:
            'Detailed analysis of prescription fills and savings across various programs',
          image: CostPercentile,
          path: '/savings-utilization',
        },
      ],
    },
    {
      category: 'Risk Profile',
      subTitle:
        'Focuses on categorizing members into risk tiers based on various health and utilization metrics. The goal is to identify and manage high-risk groups effectively, providing insights into their healthcare needs and cost implications.',
      image: RiskProfile,
      subGroups: [
        {
          group: 'Chronic Condition Comorbidity',
          subTitle:
            'Categorizes members into five risk tiers based on the number of chronic conditions they have, from 6+ conditions in the highest risk tier to no chronic conditions in the lowest risk tier.',
          image: ChronicConditions,
          path: '/risk-profiling-by-chronic',
        },
        {
          group: 'Trigger Condition Comorbidity',
          subTitle:
            'Categorizes members into five risk tiers based on trigger conditions identified by the SIIA, with the highest risk tier for those with multiple trigger conditions and the lowest risk tier for those with none.',
          image: TriggerConditions,
          path: '/risk-profiling-by-trigger',
        },
        {
          group: 'Cost Percentile',
          subTitle:
            'Tiers members based on their healthcare costs, with the highest tier representing the top 1 percentile of spenders and the lowest tier representing the bottom 60 percentile.',
          image: CostPercentile,
          path: '/risk-profiling-by-cost',
        },
        {
          group: 'High Cost Services Utilization',
          subTitle:
            'Categorizes members based on their utilization of high-cost services such as emergency care, urgent care, and surgeries, with the highest tier for those using more than 5 services and the lowest tier for those using none.',
          image: HighCostUtilization,
          path: '/risk-profiling-by-utilization',
        },
        // {
        //   group: 'Multiple Drug Consumption',
        //   subTitle:
        //     'Tiers members based on the number of different medications they are taking simultaneously, identifying those with the highest medication usage for targeted intervention.',
        //   image: MultipleDrugs,
        //   path: '/risk-profiling-by-drugs',
        // },
      ],
    },
    {
      category: 'Deep Dive',
      subTitle: "Explore the drivers behind the cost and it's trend.",
      path: '/deep-dive',
      image: DeepDive,
    },
    {
      category: 'Trend Analysis',
      subTitle: "Explore the drivers behind the cost and it's trend.",
      path: '/trend-analysis',
      image: TrendAnalysis,
    },
    {
      category: 'Cohort Comparison',
      subTitle:
        "Explore the drivers behind the cost and it's trend based on the cohorts.",
      path: '/cohort-comparison',
      image: CohortComparison,
    },
    {
      category: 'Payment Integrity',
      subTitle: 'Overview of Payment Accuracy and Claim Integrity Insights',
      path: '/payment-integrity',
      image: PaymentIntegrity,
    },
    {
      category: 'CMS Benchmark',
      subTitle:
        'This view benchmarks only procedures where a CMS rate is available (CLFS, ASP, MPFS). Other lines within the same claim are not benchmarked, so benchmarked spend will be lower than total medical spend',
      path: '/cms-benchmark',
      image: CMSBenchmarking,
    },
  ],
  PLAN_DOCUMENT_CARDS: [
    {
      category: 'Plan Documents',
      subTitle:
        'Explore the intricacies of your Plan Document with our intelligent search feature, designed to streamline your access to critical information alongside a thorough review report ensuring regulatory compliance.',
      image: SummaryOfBenefits,
      path: '/plan-documents',
    },
    {
      category: 'Contracts',
      subTitle:
        'Command your contractual landscape with a robust document management tool designed to align health plan contracts with precision, ensuring they meet the pinnacle of regulatory compliance and best practices.',
      image: Contracts,
      path: '/contract',
    },
  ],
  PLAYBOOK_CARDS: [
    {
      category: 'Draft Agreement Analyzer',
      subTitle:
        'Explore the foundational agreements that govern your employee benefit plan, providing transparency into key partnerships.',
      image: DraftReportBuilder,
      path: '/draft-agreements',
    },
    {
      category: 'M&A Due Diligence',
      subTitle:
        'Analyze acquisition documents for risks, liabilities, and due diligence metrics for PE firms.',
      image: MAndAReportBuilder,
      path: '/due-diligence',
    },
    {
      category: 'Document Comparison',
      subTitle:
        'Compare contracts across groups to see where key terms align, vary, or are missing.',
      image: DocumentReportBuilder,
      path: '/doc-comparison',
    },
    {
      category: 'Term Compiler',
      subTitle:
        'Browse and search all your term compilations—see status, sources, topics, and evidence at a glance.  Open any to review or export, or click New Compilation to assemble definitions across documents with citations.',
      image: TermReportBuilder,
      path: '/term-compiler',
    },
    {
      category: 'Annual Renewal Process',
      subTitle:
        'Manage all upcoming contract renewals in one place. Review key details, track renewal dates, and decide whether to extend with the current vendor or initiate a new RFP process. Stay on top of expiring contracts, identify red flags, and ensure smooth vendor transitions with timely actions',
      image: AnnualRenewalProcess,
      path: '/annual-renewal-process',
    },
    {
      category: 'Playbook & Standard',
      subTitle:
        'Simplify compliance with step-by-step playbooks and industry-standard best practices.',
      image: PlaybookAndStandard,
      path: '/playbook-and-standards',
    },
    {
      category: 'Proposal Analyzer',
      subTitle:
        'Make proposal evaluation faster, clearer, and more defensible.',
      image: DraftProposal,
      path: '/proposal-analyzer',
    },
  ],
  ALL_REPORTS_CARDS: [
    {
      category: 'Compliance PDF Builder',
      subTitle:
        'Select compliance checks from regulatory to inter-document conflicts; compile into a single PDF or download individual PDFs.',
      image: ComplianceReportBuilder,
      path: '/compliance-report',
    },
    {
      category: 'Claims Analytics PDF Builder',
      subTitle:
        'Select claims analytics from utilization to financials; compile into a single PDF or download individual PDFs.',
      image: ClaimsReportBuilder,
      path: '/reports',
    },
  ],
  CUSTOM_ANALYSIS_CARDS: [
    {
      category: 'Custom Query Builder',
      subTitle:
        'Unlock the power of data with the Custom Query Builder, an intuitive interface that allows you to craft and extract specific datasets from claims information. Forge detailed lists, from patient demographics to disease prevalence, and analyze the financial impact with precision.',
      image: CustomQueryBuilder,
      path: '/custom-query-builder',
    },
    {
      category: 'KPI Tracker',
      subTitle:
        'Elevate your strategic monitoring with the KPI Tracker, a dynamic tool enabling you to measure the performance of healthcare contracts. Select from a suite of metrics or define your own to assess engagement, ROI, enrollment patterns, and more, ensuring your objectives are not just met but exceeded.',
      image: KPITracker,
      path: '/kpi-tracker',
    },
    {
      category: 'Cohort Analysis',
      subTitle:
        'Focused on creating and analyzing specific member cohorts based on various criteria that helps in identifying targeted interventions, understanding cost patterns, and improving overall healthcare management by providing insights into specific member groups.',
      image: CohortAnalysis,
      subGroups: [
        {
          group: 'Chronic Condition Cohort',
          subTitle:
            'Create cohorts of members with one or multiple chronic conditions to analyze their PMPM costs, drug usage patterns, and identify the list of members with these conditions.',
          image: CohortChronicCondition,
          path: '/chronic-cohort-analysis',
        },
        // {
        //   group: 'Multiple Drugs Consumption Cohort',
        //   subTitle:
        //     'Identify members based on the number of drugs they consume simultaneously, analyze high drug consumption, drug usage patterns, therapeutic class overlap, and adherence.',
        //   image: CohortDrug,
        //   path: '/multiple-drug-cohort',
        // },
        {
          group: 'High Cost Claimants Cohort',
          subTitle:
            'Identify members with an average monthly cost of care greater than $600, analyze these members, and remove high-cost outliers that skew PMPM due to non-impactable conditions like cancers or accidents.',
          image: CohortHighCost,
          path: '/high-cost-cohort',
        },
      ],
    },
  ],
  CUSTOM_ANALYSIS_ADDITIONAL_CARDS: [
    {
      category: 'Claims List',
      subTitle: ' See all your claims and create filters as required',
      image: ClaimsList,
      path: '/claims-list',
    },
    {
      category: 'Members List',
      subTitle: 'See all your members and create cohorts as required',
      image: MembersList,
      path: '/members-list',
    },
  ],
  RECOMMENDATION_CARDS: [
    {
      category: 'Claim Analysis',
      subTitle:
        'Leverage tailored suggestions stemming from an in-depth examination of medical and RX claims data. Identify and address abnormalities, monitor shifts in healthcare spending, and unveil opportunities to enhance population health while streamlining costs.',
      image: ClaimAnalysis,
      path: '/claim-analysis',
    },
    {
      category: 'Contract Analysis',
      subTitle:
        'Access actionable advice derived from meticulous contract evaluations against regulatory standards and industry benchmarks. Ensure your agreements not only comply with legislative demands but also embody the pinnacle of industry procurement practices.',
      image: ContractAnalysis,
      path: '/contract-risk-analysis',
    },
  ],
};

export default accessDashboardConstants;
